import { Box, Stack, TextField, Container, Typography, Link } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { LoadingButton } from '@mui/lab';
import Page from 'src/components/Page';
import useRecoveryPassword from '../hooks/useRecoveryPassword';

export default function RecoveryPassword() {
	const { email, onChange, error, enviaEmail, isSubmitting } = useRecoveryPassword();

	return <Page title="Recupere sua senha">
		<Box mt={28} />
		<Container maxWidth='xs'>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				spacing={3}
			>
				<LockOutlinedIcon sx={{ fontSize: 62 }} />
				<Typography variant="h3" textAlign='center'>Esqueceu sua senha?</Typography>
				<Typography textAlign='center' variant='body1' sx={{ color: 'rgb(99, 115, 129)' }}>
					Por favor, insira o endereço de e-mail associado à sua conta
					e nós lhe enviaremos um link para redefinir sua senha.
				</Typography>
				<TextField
					label="Endereço de e-mail"
					fullWidth
					value={email}
					onChange={onChange}
					error={error}
					helperText={error && "Endereço de email inválido"}
				/>
				<LoadingButton onClick={enviaEmail} sx={{ width: '100%', height: '48px' }} variant="contained" loading={isSubmitting}>
					Enviar
				</LoadingButton>
				<Link href="/login" variant="body2">{"<"} Retornar para login</Link>
			</Stack>
		</Container>
	</Page>
}